import React, { Component } from 'react';
import AuthFunctions from '../services/AuthService';
import AdminFunctions from '../admin/AdminFunctions';
import WorkOrderFunctions from '../services/WorkOrderService';
import { Container, Row, Col, Input, Button, Table, Spinner, UncontrolledTooltip } from 'reactstrap';
import { FaSort } from 'react-icons/fa'
import '../layout/site.css';

export class InquireOrder extends Component {
    static displayName = InquireOrder.name;

    constructor(props) {
        super(props);

        this.state = {
            siteList: [],
            client: null,
            search: null,
            ordersOrig: [],
            orders: [],
            //isAdmin: false,
            height: 0,
            width: 0,
            sort: {
                column: null,
                direction: 'desc'
            },
            loading: false,
            noResults: false,
            currentPage: 1,
            itemsPerPage: 100,
            numberOfPages: 0,
            partNo: '',
            poNum: '',
            mte: '',
            serialNo: '',
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.searchOrders = this.searchOrders.bind(this);
        this.getOrderData = this.getOrderData.bind(this);
        this.checkAuthenticated();
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
    }

    handleClick(event) {
        let id = Number(event.target.id);

        if (id === 0) {
            this.setState({
                currentPage: 1
            });
        } else if (id === -1) {
            this.setState({
                currentPage: Math.ceil(this.state.orders.length / this.state.itemsPerPage)
            });
        } else {
            this.setState({
                currentPage: Number(event.target.id)
            });
        }
    }

    handleChange(event) {
        this.setState({ currentPage: Number(event.target.value) });
    }

    handlePageSizeChange(event) {
        let pageSize = Number(event.target.value);
        this.setState({ itemsPerPage: pageSize });
        if (this.state.currentPage > Math.ceil(this.state.orders.length / pageSize)) {
            this.setState({ currentPage: Math.ceil(this.state.orders.length / pageSize) })
        }
    }

    handleSearch() {
        this.searchOrders();
    }

    async getOrderData() {
        var orders = await WorkOrderFunctions.getWorkOrdersAsync();

        if (orders.success == true) {
            if (orders.data != null) {
                var original = orders.data;
                var filtered = original.slice(0);
                this.setState({ orders: filtered, ordersOrig: original});
            }
        }
    }

    async componentDidMount() {
        document.getElementsByTagName('html')[0].className = "";

        const isAdmin = await AdminFunctions.isAdminAsync();
        this.setState({ isAdmin: isAdmin });
        if (isAdmin) {

        }
        else {
        }
        this.getOrderData();
    }

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.searchOrders();
        }
    }

    render() {
        // Logic for displaying instruments!
        const indexOfLastItem = this.state.currentPage * this.state.itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - this.state.itemsPerPage;
        const currentItems = this.state.orders.slice(indexOfFirstItem, indexOfLastItem);

        const renderItems = currentItems.map((order, i) => {
            return (
                <tr key={order.workOrder}>
                    <td>{order.customerPO}</td>
                    <td>{order.partNo}</td>
                    <td>{order.mte}</td>
                    <td>{order.serialNo}</td>
                    <td>{order.noun}</td>
                    <td>{order.status}</td>
                </tr>
            )
        });

        // Logic for displaying page numbers
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(this.state.orders.length / this.state.itemsPerPage); i++) {
            pageNumbers.push(i);
        }

        const renderPageNumbers = pageNumbers.map(number => {
            return (
                <option value={number}>{number}</option>
            );
        });

        return (
            <div>
                <Container>
                    <Row>
                        <Col>
                            <h2 style={{ color: '#233c7c' }}>Inquire Order Status</h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Row>
                                <Col>
                                    <Input
                                        type='text'
                                        onChange={(e) => this.setState({ poNum: e.target.value })}
                                        className='fullInput'
                                        onKeyPress={this.handleKeyPress}
                                        placeholder='PO #'
                                    />
                                </Col>
                                <Col>
                                    <Input
                                        type='text'
                                        onChange={(e) => this.setState({ partNo: e.target.value })}
                                        className='fullInput'
                                        onKeyPress={this.handleKeyPress}
                                        placeholder='R#'
                                    />
                                </Col>
                                <Col>
                                    <Input
                                        type='text'
                                        onChange={(e) => this.setState({ mte: e.target.value })}
                                        className='fullInput'
                                        onKeyPress={this.handleKeyPress}
                                        placeholder='M&TE#'
                                    />
                                </Col>
                                <Col>
                                    <Input
                                        type='text'
                                        onChange={(e) => this.setState({ serialNo: e.target.value })}
                                        className='fullInput'
                                        onKeyPress={this.handleKeyPress}
                                        placeholder='S/N'
                                    />
                                </Col>

                                <Col className='buttonCol' style={{ textAlign: 'right' }}>
                                    <Button
                                        color='primary'
                                        style={{ width: '125px' }}
                                        className='standardButton'
                                        onClick={() => this.searchOrders()}
                                        disabled={this.state.loading ? true : false}
                                    >
                                        Search
                                    </Button>
                                </Col>
                            </Row>

                        </Col>
                    </Row>
                    {this.state.orders.length !== 0 && (
                        <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'right', textAlign: 'center', marginTop: '20px' }}>
                            <label style={{ marginRight: '10px', marginTop: '5px' }}>Page</label>
                            <select className='form-control' style={{ width: '75px' }} value={this.state.currentPage} onChange={this.handleChange}>
                                {renderPageNumbers}
                            </select>
                            <label style={{ marginRight: '10px', marginLeft: '10px', marginTop: '5px' }}>Page Size</label>
                            <select className='form-control' style={{ width: '75px' }} value={this.state.itemsPerPage} onChange={this.handlePageSizeChange}>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                    )}
                    <Row style={{ marginTop: '20px' }}>
                        <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>
                                            PO#
                                            <FaSort
                                                color={this.state.sort.column === 'customerPO' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('customerPO')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th>
                                            R#
                                            <FaSort
                                                color={this.state.sort.column === 'partNo' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('partNo')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th>
                                            M&TE#
                                            <FaSort
                                                color={this.state.sort.column === 'mte' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('mte')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th>
                                            S/N
                                            <FaSort
                                                color={this.state.sort.column === 'serialNo' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('serialNo')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th>
                                            Noun
                                            <FaSort
                                                color={this.state.sort.column === 'noun' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('noun')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th>
                                            Status
                                            <FaSort
                                                color={this.state.sort.column === 'status' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('status')}
                                                className='sort-button'
                                            />
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.loading === true && this.state.loadingDocument === false ? (
                                        <tr>
                                            <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '50vh', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                <Spinner color="primary" children='' />
                                            </td>
                                        </tr>

                                    ) : (
                                        <>
                                            {!this.state.noResults ? (
                                                <>
                                                    {renderItems}
                                                </>
                                            ) : (
                                                <tr>
                                                    <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                        <h5>No Results Found</h5>
                                                    </td>
                                                </tr>
                                            )}
                                        </>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    {this.state.orders.length !== 0 && (
                        <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'right', textAlign: 'center', marginTop: '20px', marginBottom: '50px' }}>
                            <label style={{ marginRight: '10px', marginTop: '5px' }}>Page</label>
                            <select className='form-control' style={{ width: '75px' }} value={this.state.currentPage} onChange={this.handleChange}>
                                {renderPageNumbers}
                            </select>
                            <label style={{ marginRight: '10px', marginLeft: '10px', marginTop: '5px' }}>Page Size</label>
                            <select className='form-control' style={{ width: '75px' }} value={this.state.itemsPerPage} onChange={this.handlePageSizeChange}>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>

                        </div>
                    )}
                </Container>
            </div>
        )
    }

    async searchOrders() {
        var poNum = this.state.poNum;
        var partNo = this.state.partNo;
        var mte = this.state.mte;
        var serialNo = this.state.serialNo;

        var orders = this.state.ordersOrig;

        if (poNum != null && poNum != "") {
            orders = orders.filter(function (order) {
                return order.customerPO.toLowerCase().includes(poNum.toLowerCase());
            });
        }
        if (partNo != null && partNo != "") {
            orders = orders.filter(function (order) {
                return order.partNo.toLowerCase().includes(partNo.toLowerCase());
            });
        }
        if (mte != null && mte != "") {
            orders = orders.filter(function (order) {
                return order.mte.toLowerCase().includes(mte.toLowerCase());
            });
        }
        if (serialNo != null && serialNo != "") {
            orders = orders.filter(function (order) {
                return order.serialNo.toLowerCase().includes(serialNo.toLowerCase());
            });
        }

        this.setState({ orders: orders });
    }

    // table sort

    handleSort(column) {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        const data = this.state.orders;

        data.sort(function (a, b) {
            if (!a[column]) return -1;

            if (!b[column]) return +1;

            return (a[column] instanceof Date ? (b[column] - a[column]) : a[column].localeCompare(b[column]));
        });

        if (direction === 'desc') {
            data.reverse();
        }
        this.setState({
            orders: data,
            sort: {
                column,
                direction
            }
        })
    }
}